import { Icon, IconProps } from '@chakra-ui/react'
import { FC } from 'react'

const ArrowRightOmens: FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 30 28" height="32px" fill={props.fill || 'darkchoc'} {...props}>
      <path d="m10.7 25.8-3.5-3.5 6.8-6.7H0v-5h13.9L7.2 3.8 10.7.3l11.1 11c.5.5.7 1.1.7 1.8s-.3 1.3-.7 1.8L10.7 25.8z" />
    </Icon>
  )
}

export default ArrowRightOmens
